import {Directive, Input, TemplateRef, ViewContainerRef} from '@angular/core';
import {PermissionHelperModule} from '../../helpers/core/PermissionHelperModule';
import {DataSharing} from '../../helpers/core/data.sharing';

@Directive({
    selector: '[appCheckPermissions]'
})
export class CheckPermissionsDirective {
    private exist: boolean;
    private pageToken: string;
    constructor(private templateRef: TemplateRef<any>, private viewContainer: ViewContainerRef) {
        this.pageToken = DataSharing.getPageToken();
    }

    @Input()
    set appCheckPermissions(permission) {
        const self = this;
        self.exist = false;
        if (self.pageToken) {
            this.viewContainer.createEmbeddedView(this.templateRef);
        } else {
            for (const v of permission) {
                if (PermissionHelperModule.CheckPermissionExist(v)) {
                    self.exist = true;
                }
            }
            if (self.exist) {
                // If condition is true add template to DOM
                this.viewContainer.createEmbeddedView(this.templateRef);
            } else {
                // Else remove template from DOM
                this.viewContainer.clear();
            }
        }
    }

}
